import { CodeTypeAct } from 'civil-status/constants/code-type-act';
import { SectionVM } from 'civil-status/view-models/step-form';
import { DateTime } from 'luxon';
import { AttoModelEvento } from 'shell/models/act-category-list';

export const transformerGeneralAct = (values?: AttoModelEvento): SectionVM | undefined => {
  if (!values) {
    return;
  }

  const typeAct = Boolean(values?.idAnsc) ? CodeTypeAct.attoDigitale : CodeTypeAct.attoCartaceo;

  return {
    typeAct,
    actForm: {
      idAnsc: values?.idAnsc,
      dateAct: values?.dataformazione ? DateTime.fromISO(values?.dataformazione) : null,
      italian: values?.idComuneRegistrazione
        ? {
            municipality: {
              id: values?.idComuneRegistrazione || '',
              code: values?.idComuneRegistrazione
                ? Number.parseInt(values?.idComuneRegistrazione, 10)
                : undefined,
              description: values.nomeComuneRegistrazione || '',
              province: values.siglaProvinciaRegistrazione || '',
              idProvince: values.idProvinciaRegistrazione
                ? Number.parseInt(values.idProvinciaRegistrazione, 10)
                : undefined,
            },
          }
        : undefined,
      register: values.tipologia || values.idTipoEvento,
      year: values?.annoAtto || '',
      municipalNumber: values?.numeroatto || '',
      typeEvent: values?.idtipocontenuto || '',
      //   portion: values?.parte || '',
      //   serie: values?.serie || '',
      //   volume: values?.volume || '',
    },
  };
};
